import { apiFetchV2 } from '@m/utils/http';

import type { PaymentMethod } from '@m/types/api';

/**
 * Shape returned by GET .../payment-methods/{userPaymentMethodId}/active-mandate.
 * A non-null value means there is an active mandate; null means there is none.
 * The exact field set is owned by EnterprisePaymentProfileController.getActiveMandate.
 */
export type ActiveMandate = {
  id?: number | string;
  status?: string | null;
};

export const EnterprisePaymentProfileService = {
  acceptMandate: ({
    enterpriseId,
    userPaymentMethodId,
  }: {
    enterpriseId: number;
    userPaymentMethodId: number;
  }) =>
    // Responds with an empty object on success; the result isn't consumed.
    apiFetchV2<void>(`/portal/enterprise/${enterpriseId}/payment-methods/accept-mandate`, {
      method: 'POST',
      body: { userPaymentMethodId },
    }),

  getActiveMandate: async ({
    enterpriseId,
    userPaymentMethodId,
  }: {
    enterpriseId: number;
    userPaymentMethodId: number;
  }) => {
    // Endpoint responds with { mandate: <mandate-or-null> }; unwrap so callers get the
    // mandate (or null) directly rather than the wrapper object.
    const response = await apiFetchV2<{ mandate: ActiveMandate | null }>(
      `/portal/enterprise/${enterpriseId}/payment-methods/${userPaymentMethodId}/active-mandate`,
    );
    return response.mandate ?? null;
  },

  getDefaultPaymentMethod: ({ enterpriseId }: { enterpriseId: number }) =>
    apiFetchV2<{ paymentMethod: PaymentMethod | null }>(
      `/portal/enterprise/${enterpriseId}/payment-methods/default`,
    ),
};
